import BaseUtil from "../../../util/BaseUtil";
import BusinessConstants from "../../../constant/BusinessConstants";

const type = `@@ActionType/UPDATE@${__filename}`;

const initState = {
    loading: false, // 加载
    units: null, // 科室树
    expandedUnits: [], // 展开科室id
    checkedUnits: [], // 选中科室id

    isWardUnits: [], // 病区科室id
    saving: false, // 保存中
};

export const defaultUserType = {
    [BusinessConstants.USER_TYPE.EMPLOYEE.code]: BusinessConstants.USER_TYPE.EMPLOYEE,
    [BusinessConstants.USER_TYPE.DOCTOR.code]: BusinessConstants.USER_TYPE.DOCTOR,
    [BusinessConstants.USER_TYPE.TECHNICIAN.code]: BusinessConstants.USER_TYPE.TECHNICIAN,
    [BusinessConstants.USER_TYPE.SUPPORT.code]: BusinessConstants.USER_TYPE.SUPPORT,
    [BusinessConstants.USER_TYPE.OFFICE.code]: BusinessConstants.USER_TYPE.OFFICE,
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
};
export default viewModel;
